import { render, staticRenderFns } from "./TabWithdrawReject.vue?vue&type=template&id=2172e644&scoped=true&"
import script from "./TabWithdrawReject.vue?vue&type=script&lang=js&"
export * from "./TabWithdrawReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172e644",
  null
  
)

export default component.exports